import { HOW_IT_WORK_GET_LIST } from "../../../redux/contants";

// eslint-disable-next-line import/prefer-default-export
export const getHowItWork = (data) => ({
    type: HOW_IT_WORK_GET_LIST,
    payload: data
});
